import React, { useEffect, useState, useMemo } from "react";
import axiosInstance from "../../../../axios";
import { getPaginatedData } from "../../../../_helpers";
import { Loading } from "../../../Other/Loading";
import Pagination from "./Pagination";
import { FaSort } from "react-icons/fa";

const { REACT_APP_LOGIN_API_BASEURL } = process.env;

const MonthReport = () => {
  const [MonthData, setMonthData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" }); // Sorting state

  const { data, startIndex, totalPageCount } = getPaginatedData(
    MonthData,
    currentPage
  );

  useEffect(() => {
    const fetchMonthlyCourseReport = async () => {
      try {
        const res = await axiosInstance.get(`${REACT_APP_LOGIN_API_BASEURL}/v2/monthly-course-report`);
        setMonthData(res?.data?.data);
      } catch (error) {
        console.error("Error fetching monthly course report:", error.message);
      }
    };

    fetchMonthlyCourseReport();
  }, []);


  // Sorting handler
  const handleSort = (key) => {
    let direction = "asc";
    if (sortConfig.key === key && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ key, direction });
  };

  // Sorted data
  const sortedData = useMemo(() => {
    if (!sortConfig.key) return MonthData;
    const sorted = [...MonthData].sort((a, b) => {
      let aValue = a[sortConfig.key];
      let bValue = b[sortConfig.key];

      // Handle numeric sorting
      if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "asc"
          ? aValue - bValue
          : bValue - aValue;
      }

      // Handle string sorting
      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "asc"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      }

      return 0;
    });
    return sorted;
  }, [MonthData, sortConfig]);

  // Helper to render sort icons
  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) return <FaSort className="text-gray-400" />;
    return sortConfig.direction === "asc" ? "▲" : "▼";
  };

  return (
    <div className="width-0">
      <div className="dashboard-container-new">
        <p>Month Wise Report</p>
        <div>
          <button className="lastmonth-btn">Last Month</button>
          <button className="export-btn">Export</button>
        </div>
      </div>

      <div className="page-data-new">
        {data?.length > 0 ? (
          <p className="showing-result">
            Showing page {currentPage} of {totalPageCount} results
          </p>
        ) : (
          <p className="showing-result">Showing 0 result</p>
        )}
      </div>

      <div className="instructor-table">
        {data.length === 0 ? (
          <Loading />
        ) : (
          <table className="table-width-100">
            <thead>
              <tr>
                <th
                  onClick={() => handleSort("Sno")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    S.no {renderSortIcon("Sno")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("Month")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Month {renderSortIcon("Month")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("Students")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Student Enrolled {renderSortIcon("Students")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("Instructors")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Instructor Enrolled {renderSortIcon("Instructors")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("CourseCreated")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Course Created {renderSortIcon("CourseCreated")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("CoursesPurchased")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Courses Purchased {renderSortIcon("CoursesPurchased")}
                  </div>
                </th>
                <th
                  onClick={() => handleSort("BundlePurchased")}
                  style={{ cursor: "pointer" }}
                >
                  <div className="flex items-center gap-1">
                    Bundle Purchased {renderSortIcon("BundlePurchased")}
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              {sortedData.map((ele, index) => {
                return (
                  <tr key={index}>
                    <td className="cell">{startIndex + index}</td>
                    <td className="cell">
                      {ele?.Month === null ? "-" : ele.Month}
                    </td>
                    <td className="cell">
                      {ele?.Students === null || !ele.Students
                        ? "-"
                        : ele.Students}
                    </td>
                    <td className="cell">
                      {ele?.Instructors === null || !ele.Instructors
                        ? "-"
                        : ele.Instructors}
                    </td>
                    <td className="cell">
                      {ele?.CourseCreated === null || !ele.CourseCreated
                        ? "-"
                        : ele.CourseCreated}
                    </td>
                    <td className="cell">
                      {ele?.CoursesPurchased === null || !ele.CoursesPurchased
                        ? "-"
                        : ele.CoursesPurchased}
                    </td>
                    <td className="cell">
                      {ele.BundlePurchased === null || !ele.BundlePurchased
                        ? "-"
                        : ele.CoursesPurchased}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
      <div className="pageNumbers-sudents">
        <Pagination
          className="pageNumbers-sudents"
          currentPage={currentPage}
          totalCount={10}
          pageSize={totalPageCount}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
    </div>
  );
};

export default MonthReport;
